'use client';

import { useState } from "react";
import "../../styles/ReusableStyles/Logo.css";

const LOGO_PART_1 = "/LogoPart1.webp";
const LOGO_PART_2 = "/LogoPart2.webp";
const LOGO_PART_3 = "/LogoPart3.webp";

const Logo = () => {
  const [rotateO, setRotateO] = useState(false);

  return (
    <a
      href="https://natoe.ai"
      target="_blank"
      rel="noopener noreferrer"
      className="logo-container"
      onMouseEnter={() => setRotateO(true)}
      onMouseLeave={() => setRotateO(false)}
      aria-label="Natoe AI home"
    >
      <div className="logo">
        <img src={LOGO_PART_1} alt="Natoe AI" className="logo-part logo-part-1" width={60} height={24} />
        <img
          src={LOGO_PART_2}
          alt=""
          role="presentation"
          width={24}
          height={24}
          className={`logo-part rotating-o ${rotateO ? "rotate" : ""}`}
        />
        <img src={LOGO_PART_3} alt="" role="presentation" className="logo-part logo-part-2" width={60} height={24} />
      </div>
    </a>
  );
};

export default Logo;
